import { SearchResult } from "../types/search.types";

//@ts-expect-error
const { __ } = wp?.i18n || window.wp.i18n;

export class ResultCardService {
  constructor() {}

  public toKebabCase = (str: string) =>
    str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();

  public getCurrencyFormat = (value: number, toFixed: number = 2) => {
    if (isNaN(value) || value === null) {
      return "$0";
    }

    return `$${value.toFixed(toFixed)}`;
  };

  public getPayee = (value: SearchResult["whoPays"]) => {
    const textArray = [
      __("User pays", "xchange-public-leasing-search-v2"),
      __("Supplier pays", "xchange-public-leasing-search-v2"),
    ];

    return value === "user" ? textArray[0] : textArray[1];
  };
}
